import Module from '../utils/modules/Module'

export default class TestModule extends Module {
  constructor (options) {
    super(options)
  }

  init () {
  }
}
